<script>
import { AvailabilityState } from '@/shared/constants/candidate/CandidateAvailability'

const { Empty, Header, Available, Unavailable } = AvailabilityState

export default {
  name: 'CandidateAvailabilityItem',
  props: {
    state: {
      type: String,
      default: null,
      validator: (value) =>
        value === null || Object.values(AvailabilityState).includes(value),
    },
    label: {
      type: [String, Number],
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isHeader() {
      return this.state === Header
    },
    hasContent() {
      return this.state !== null && this.state !== Empty
    },
    backgroundClass() {
      const backgroundClassByState = {
        [Available]: 'semantics-success-50',
        [Unavailable]: 'semantics-error-50',
      }

      return backgroundClassByState[this.state] ?? null
    },
    ariaLabel() {
      return !this.isLoading || this.hasContent || !this.isHeader
        ? this.label
        : null
    },
  },
}
</script>

<template>
  <div
    class="availability-item w-100 rounded-lg overflow-hidden"
    :aria-hidden="isLoading || !hasContent"
    :aria-label="ariaLabel"
  >
    <transition name="fade" mode="out-in">
      <v-skeleton-loader
        v-if="isLoading"
        key="loading"
        type="image"
        class="w-100 h-100"
        height="44"
      />
      <div
        v-else-if="hasContent"
        key="content"
        class="availability-item-content w-100 h-100 d-flex align-center justify-center text-md"
        :class="[backgroundClass, { 'neutrals-grey-500-text': isHeader }]"
      >
        <span>{{ label }}</span>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_vue-transitions.scss';

.fade-enter-active,
.fade-leave-active {
  transition-timing-function: ease-in-out;
}

.availability-item {
  max-width: 90px;
  height: 44px;
}

.availability-item-loader,
.availability-item-content {
  border-radius: inherit;
}

::v-deep .availability-item-loader .v-skeleton-loader__image {
  height: 44px;
}
</style>
